import { Injectable } from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {
  Deposit,
  DepositConservation,
  DepositState
} from 'app/archivage/common/services/deposit/deposit.model';
import {HttpClient} from '@angular/common/http';
import {environment} from '@Env/environment';
import {HelperDeposit} from '../../helper/helperDeposit';
import {map} from 'rxjs/operators';
import {Entite} from '@Services/gestion-universite/entite/entite.model';
import {DirCmpEntite} from '../dircmp/dircmp.model';

@Injectable({
  providedIn: 'root'
})
export class DepositService extends DaoGeneric<Deposit> {
  private url = `${environment.baseUrl}/api_archive/deposit/`;
  readonly state: string[] = [];
  readonly conservation: string[] = [];

  constructor(private httpClient: HttpClient) {
    super(httpClient);

    this.state[DepositState.DONE] = 'Fini';
    this.state[DepositState.WAITING] = 'En attente';
    this.state[DepositState.DRAFT] = 'Brouillon';
    this.state[DepositState.INCOMPLETE] = 'A compléter';
    this.state[DepositState.ARCHIVED] = 'Archivé';

    this.conservation[DepositConservation.UNDEF] = 'Non défini';
    this.conservation[DepositConservation.INTEGRAL] = 'Conservation';
    this.conservation[DepositConservation.PARTIAL] = 'Tri';
    this.conservation[DepositConservation.ELIMINATE] = 'Destruction';
    this.conservation[DepositConservation.SCAN] = 'Numérisation';
  }

  getRootUrl(): string {
    return this.url;
  }

  displayStateNames(enumState: number) {
    return this.state[enumState];
  }

  displayState(deposit: Deposit): string {
    return this.state[deposit?.state ?? DepositState.DRAFT];
  }
  getChipButton(deposit: Deposit): string {
    return this.getChipButtonByState(deposit.state);
  }
  getChipButtonByState(state: DepositState) {
    const stateLabel = this.displayStateNames(state);
    const classType = HelperDeposit.getClassColorBtnChip(state);
    return `<small><span class="state-consultation-chip ${classType}">${stateLabel}</span></small>`;
  }
  displayConservation(deposit: Deposit): string {
    return this.displayConservationByType(deposit?.conservation);
  }
  displayConservationByType(conservation: DepositConservation) {
    return this.conservation[conservation ?? DepositConservation.UNDEF];
  }
  selectConservation() {
    return [
      {id: DepositConservation.INTEGRAL, label: this.conservation[DepositConservation.INTEGRAL]},
      {id: DepositConservation.PARTIAL, label: this.conservation[DepositConservation.PARTIAL]},
      {id: DepositConservation.ELIMINATE, label: this.conservation[DepositConservation.ELIMINATE]},
      {id: DepositConservation.SCAN, label: this.conservation[DepositConservation.SCAN]},
    ];
  }

  createOrUpdateNestedDeposit(deposit: Deposit) {
    const url = `${this.url}bulk/`;
    return this.httpClient.put<Deposit>(url, deposit);
  }

  displayConservationDefault(cons: DepositConservation) {
    return this.conservation[cons ?? DepositConservation.UNDEF];
  }
  displayDUA(dua: number) {
    return dua ? dua.toString() : 'N/A';
  }
  public exportBoxPdf(deposit: Deposit) {
    const url = `${this.url}${deposit.id}/export_box_pdf/`;
    return this.httpClient.get(url, {
      responseType: 'blob'
    }).pipe(map((data: any) => new Blob([data])));
  }
  public exportDepositPdf(deposit: Deposit) {
    const url = `${this.url}${deposit.id}/export_deposit_pdf/`;
    return this.httpClient.get(url, {
      responseType: 'blob'
    }).pipe(map((data: any) => new Blob([data])));
  }

  /**
   * Liste des dir / cmp des dépôts existants
   */
  dirCmpDeposits(states: DepositState[] = []) {
    const _states = states;
    let _params;
    if (states?.length > 0) {
      _params = {
        states: _states
      };
    }
    const url = `${this.url}dir_cmp_deposits/`;
    return this.httpClient.get<DirCmpEntite[]>(url, {params: _params});
  }

  depositBel() {
    const url = `${this.url}deposit_bel/`;
    return this.httpClient.get<string[]>(url);
  }
}
